import { merge } from 'lodash/fp';

import defaultTheme from '@ihme/common/theme/echarts-theme';

const textStyle = {
    fontSize: 15,
    fontFamily: '"Helvetica", sans-serif',
    color: '#222222',
    fontWeight: 400,
};

const colorPalette = [
    '#33bdd4',
    '#22b0d1',
    '#197b9f',
    '#235084',
    '#333366',
    '#404057',
    '#4b4a4b',
    '#5c5b5c',
    '#7e7c7e',
    '#a6807e',
    '#ce847e',
    '#f37b70',
    '#f06053',
    '#ea3828',
];

export default merge(defaultTheme, {
    color: colorPalette,
    loading: {
        text: 'Loading...',
        color: '#0094C9',
        textColor: '#0094C9',
        maskColor: 'rgba(255, 255, 255, 0.8)',
        zlevel: 0
    },
    textStyle,
    title: {
        top: 0,
        left: 'center',
        backgroundColor: 'rgba(255, 255, 255, .8)',
        textStyle: {
            fontFamily: '"Helvetica", sans-serif',
            fontSize: 20,
            fontWeight: 600,
        },
        subtextStyle: {
            ...textStyle,
            fontSize: 14,
        },
    },
    map: {
        locationSelectedColor: '#ECEFF1',
        locationInRangeColorSpectrum: [
            '#33bdd4',
            '#1aa9cf',
            '#0094c9',
            '#266f8a',
            '#326375',
            '#235084',
            '#333366',
            '#373762',
            '#404057',
            '#4b4a4b',
            '#656365',
            '#7e7c7e',
            '#ba827e',
            '#f5887e',
            '#f06053',
            '#ea3828',
        ],
    },
    line: {
        grid: {
            top: 80,
            left: 70,
        },
        color: [
            {
                type: 'linear',
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                    {
                        offset: 0,
                        color: '#21C7FF',
                    },
                    {
                        offset: 1,
                        color: '#0094C9',
                    },
                ],
            },
            {
                type: 'linear',
                x: 0,
                y: 1,
                x2: 0,
                y2: 0,
                colorStops: [
                    {
                        offset: 0,
                        color: '#F5887E',
                    },
                    {
                        offset: 1,
                        color: '#F26053',
                    },
                ],
            },
            '#764AC3',
            '#1E379E',
            '#A71205',
            '#C92213',
            '#EF3828',
            '#ea3828',
            '#F5887E'
        ],
        legend: {
            show: false,
        },
        symbolSize: 2,
        itemStyle: {
            borderColor: '#ED4C3B',
            borderWidth: 2,
            shadowColor: 'rgba(237, 76, 59, 0.6)',
            shadowBlur: 10,
        },
    },
    bar: {
        grid: {
            top: 80,
            height: 300,
            left: 70,
        },
        legend: {
            orient: 'vertical',
            x: 'center',
            top: '420',
            width: '90%',
            textStyle,
        },
        seriesColorSpectrum: colorPalette,
    },

    toolbox: {
        top: 24,
        right: 26,
        itemSize: 26,
        itemGap: 20,
        iconStyle: {
            color: 'rgba(0, 0, 0, .6)',
            borderWidth: 0,
            emphasis: {
                color: '#0094C9',
            },
        },
    },

    tooltip: {
        backgroundColor: 'rgba(255,255,255)',
        extraCssText:
            'box-shadow: 0 10px 10px 0 rgba(0,0,0,0.05), 0 0 10px 0 rgba(0,0,0,0.10), 0 20px 20px 0 rgba(0,0,0,0.08); border-radius: 4px;',
        padding: [16, 20],
        textStyle,
    },
    xAxis: {
        axisLine: {
            show: true,
            lineStyle: {
                color: '#ECEFF1',
                width: 2,
            },
        },
        axisLabel: {
            ...textStyle,
            showMaxLabel: true,
        },
        axisTick: {
            length: 2,
            lineStyle: {
                width: 2,
            },
        },
        splitLine: {
            show: true,
            lineStyle: {
                color: '#ECEFF1',
                opacity: 0.8,
            },
        },
        nameLocation: 'middle',
        nameTextStyle: textStyle,
        nameGap: 30,
        axisPointer: {
            lineStyle: {
                color: '#ED4C3B',
            },
        },
    },
    yAxis: {
        axisLine: {
            show: true,
            lineStyle: {
                color: '#ECEFF1',
                width: 2,
            },
        },
        axisTick: {
            length: 2,
            lineStyle: {
                width: 2,
            },
        },
        axisLabel: textStyle,
        splitLine: {
            show: true,
            lineStyle: {
                color: '#ECEFF1',
                opacity: 0.8,
            },
        },
        nameLocation: 'middle',
        nameTextStyle: {
            ...textStyle,
            fontWeight: 600,
        },
        nameGap: 54,
    },
    dataZoom: {
        type: 'slider',
        textStyle: {
            fontSize: 12,
        },
        backgroundColor: '#F5F7F8',
        fillerColor: 'rgba(194,201,204, 0.25)',
        borderColor: 'transparent',
        dataBackground: {
            lineStyle: {
                color: '#ACB8BE',
            },
            areaStyle: {
                color: '#DDE3E6',
            },
        },
        handleStyle: {
            color: '#C2C9CC',
        },
    },
});
